import { render, staticRenderFns } from "./SingleAmount.vue?vue&type=template&id=1e5637a9&scoped=true&"
import script from "./SingleAmount.vue?vue&type=script&lang=ts&"
export * from "./SingleAmount.vue?vue&type=script&lang=ts&"
import style0 from "./SingleAmount.vue?vue&type=style&index=0&id=1e5637a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5637a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
